import { useNavigate } from '@tanstack/react-router';
import { P } from '@vagusx/shared';
import { useHasPermission } from '@/hooks/use-permissions';
import { CampaignList } from './CampaignList';

/** `/campaigns` (ADR-318, P10): every campaign, and the way into each. */
export default function CampaignsPage(): React.ReactElement {
  const navigate = useNavigate();
  const canEdit = useHasPermission(P.OUTREACH_EDIT);
  return (
    <CampaignList
      canEdit={canEdit}
      onNewCampaign={() => void navigate({ to: '/campaigns/new' })}
      onOpenCampaign={(id) => void navigate({ to: '/campaigns/$id', params: { id } })}
      onOpenPolicy={() => void navigate({ to: '/campaigns/rules' })}
    />
  );
}
